interface ParamsProps {
  page: number,
  size: number,
  sortParam: string,
  order: 'asc' | 'desc',
  idUnidade?: number,
  unidadeId?: number
}

export const formatParams = ({ page, size, sortParam, order, idUnidade, unidadeId }: ParamsProps) => {
  return { page, size, sort: `${sortParam},${order}`, idUnidade, unidadeId }
}